import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MaquinariaMovil from './pages/MaquinariaMovil';
import MaquinariaFija from './pages/MaquinariaFija';
import EquipmentDetail from './pages/EquipmentDetail';
import TallerView from './pages/TallerView';
import OrdenesTrabajo from './pages/OrdenesTrabajo';
import MantenimientoPreventivo from './pages/MantenimientoPreventivo';
import Alertas from './pages/Alertas';
import Inventario from './pages/Inventario';
import AlmacenArea from './pages/AlmacenArea';
import AlmacenCarpeta from './pages/AlmacenCarpeta';
import Informes from './pages/Informes';
import Admin from './pages/Admin';
import Operaciones from './pages/Operaciones';
import Incidencias from './pages/Incidencias';
import ControlAmbiental from './pages/ControlAmbiental';
import Personal from './pages/Personal';
import Accesos from './pages/Accesos';
import CuadroMandos from './pages/CuadroMandos';
import Documentos from './pages/Documentos';
import SCADA from './pages/SCADA';
import './App.css';

function ProtectedRoute({ children, requireAdmin }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#16a34a]" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout><Dashboard /></Layout>
        </ProtectedRoute>
      } />
      <Route path="/cuadro-mandos" element={
        <ProtectedRoute><Layout><CuadroMandos /></Layout></ProtectedRoute>
      } />
      <Route path="/maquinaria-movil" element={
        <ProtectedRoute><Layout><MaquinariaMovil /></Layout></ProtectedRoute>
      } />
      <Route path="/maquinaria-fija" element={
        <ProtectedRoute><Layout><MaquinariaFija /></Layout></ProtectedRoute>
      } />
      <Route path="/equipos/:id" element={
        <ProtectedRoute><Layout><EquipmentDetail /></Layout></ProtectedRoute>
      } />
      <Route path="/taller/:id" element={
        <ProtectedRoute><TallerView /></ProtectedRoute>
      } />
      <Route path="/ordenes-trabajo" element={
        <ProtectedRoute><Layout><OrdenesTrabajo /></Layout></ProtectedRoute>
      } />
      <Route path="/mantenimiento" element={
        <ProtectedRoute><Layout><MantenimientoPreventivo /></Layout></ProtectedRoute>
      } />
      <Route path="/alertas" element={
        <ProtectedRoute><Layout><Alertas /></Layout></ProtectedRoute>
      } />
      <Route path="/inventario" element={
        <ProtectedRoute><Layout><Inventario /></Layout></ProtectedRoute>
      } />
      <Route path="/inventario/area/:areaId" element={
        <ProtectedRoute><Layout><AlmacenArea /></Layout></ProtectedRoute>
      } />
      <Route path="/almacen/carpeta/:folderId" element={
        <ProtectedRoute><Layout><AlmacenCarpeta /></Layout></ProtectedRoute>
      } />
      <Route path="/informes" element={
        <ProtectedRoute><Layout><Informes /></Layout></ProtectedRoute>
      } />
      <Route path="/operaciones" element={
        <ProtectedRoute><Layout><Operaciones /></Layout></ProtectedRoute>
      } />
      <Route path="/incidencias" element={
        <ProtectedRoute><Layout><Incidencias /></Layout></ProtectedRoute>
      } />
      <Route path="/control-ambiental" element={
        <ProtectedRoute><Layout><ControlAmbiental /></Layout></ProtectedRoute>
      } />
      <Route path="/personal" element={
        <ProtectedRoute><Layout><Personal /></Layout></ProtectedRoute>
      } />
      <Route path="/accesos" element={
        <ProtectedRoute><Layout><Accesos /></Layout></ProtectedRoute>
      } />
      <Route path="/documentos" element={
        <ProtectedRoute><Layout><Documentos /></Layout></ProtectedRoute>
      } />
      <Route path="/scada" element={
        <ProtectedRoute><Layout><SCADA /></Layout></ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute requireAdmin><Layout><Admin /></Layout></ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
